import React, { useEffect, useState } from 'react';
import {
  BarChart,
  Tooltip,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Legend,
} from 'recharts';
import { formattedCurrency } from '../../../../utils/utils';

const CashierLogisticBar = (children) => {
  const { outsMoves, entriesMoves, discounts } = children;
  const [data, setData] = useState(null);

  useEffect(() => {
    const dataValues = [
      {
        name: 'Fluxo transaçoẽs de caixa',
        outsMoves: Math.abs(outsMoves),
        entriesMoves,
        discounts
      },
    ];
    setData(dataValues);
  }, []);

  return (
    <ResponsiveContainer height="100%">
      <BarChart
        data={data}
        layout="vertical"
        margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
        barSize={20}
      >
        <Tooltip
          cursor={{ fill: '#FFF' }}
          formatter={(value) => formattedCurrency(value)}
        />
        <Legend
          wrapperStyle={{ position: 'relative', bottom: 0, width: '100%' }}
        />
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis type="number" orientation="bottom" />
        <YAxis type="category" orientation="left" dataKey="name" />
        <Bar
          name="Descontos aplicados"
          dataKey="discounts"
          fill="#f39708"
          background={{ fill: '#eee' }}
        />
        <Bar
          name="Movimentações de saida"
          dataKey="outsMoves"
          fill="#D60429"
          background={{ fill: '#eee' }}
        />
        <Bar
          name="Movimentações de entrada"
          dataKey="entriesMoves"
          fill="#1B79DF"
          background={{ fill: '#eee' }}
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default CashierLogisticBar;
